"use client";

import { ColumnDef } from "@tanstack/react-table";
import { Seller } from "@/services/sellerService";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { format } from "date-fns";

export const columns: ColumnDef<Seller>[] = [
  {
    accessorKey: "name",
    header: "Seller",
    cell: ({ row }) => {
      const s = row.original;
      return <div className="text-sm font-semibold">{s.name || "-"}</div>;
    },
  },
  {
    accessorKey: "domain",
    header: "Domain",
    cell: ({ row }) => <div className="text-sm">{row.getValue("domain") || "-"}</div>,
  },
  {
    accessorKey: "onboarding_completed",
    header: "Onboarded",
    cell: ({ row }) => {
      const v = row.getValue("onboarding_completed") as boolean | undefined;
      return <div className="text-sm">{v ? "Yes" : "No"}</div>;
    },
  },
  {
    accessorKey: "subscription_plan",
    header: "Subscription",
    cell: ({ row }) => {
      const plan = row.original.subscription_plan;
      const label = plan?.name || "Free";
      return <div className="text-sm">{label}</div>;
    },
  },
  {
    accessorKey: "created_at",
    header: "Created",
    cell: ({ row }) => {
      const dt = row.getValue("created_at") as string | undefined;
      try {
        return <div className="text-sm">{dt ? format(new Date(dt), "MMM dd, yyyy") : "-"}</div>;
      } catch (e) {
        return <div className="text-sm">{dt || "-"}</div>;
      }
    },
  },
  {
    id: "actions",
    header: "Actions",
    cell: ({ row }) => {
      const s = row.original;
      return (
        <div className="flex gap-2">
          <Link to={`${s.id}`}>
            <Button size="sm">View</Button>
          </Link>
        </div>
      );
    },
  },
];
